// Development "http://localhost:3000/api/executeQuery"
// Production "https://rolo-backend-506573180721.europe-west1.run.app/api/executeQuery"

export async function executeQuery(query, values) {
  try {
    const response = await fetch("https://rolo-backend-506573180721.europe-west1.run.app/api/executeQuery", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ sql: query, values }),
      credentials: "include",
    });
    if (!response.ok) throw new Error(`Error: ${response.statusText}`);

    return await response.json();
  } catch (error) {
    console.error("executeQuery error:", error);
  }
}
